import HomeLayout from '../../layouts/Home'
import Home from './Home'

export default HomeLayout(Home)



// WEBPACK FOOTER //
// ./src/pages/home/index.js